import axios from "axios";

axios.defaults.validateStatus = () => true;

export const api = axios.create({
  baseURL: process.env.REACT_APP_URL_MANDADO,
});

export function getMandado(CADASTRO: string) {
  const storedToken = sessionStorage.getItem("@webSDS:token");
  const response = api.get("infoMandado", {
    headers: {
      Authorization: `Bearer ${storedToken}`,
      cadastro: CADASTRO,
    },
  });
  return response;
}
